import React, { useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useObservable } from 'react-use-observable';

import {
  BellOutlined as NotificationOutlineIcon,
  HistoryOutlined as HistoryIcon,
  MutedOutlined as NotificationsOffOutlinedIcon,
  NotificationOutlined as NotificationsOutlinedIcon
} from '@ant-design/icons';
import { Badge, Button, Divider, Popover, Tooltip, Typography } from 'antd';

import notificationService from 'v2/services/notifications';
import webNotificationService from 'v2/services/webNotification';

import Topbar from '@eduzz/ui-layout/Topbar';

import BankslipGenerated from './bankslipGenerated';
import HighChargebackRate from './chargebackRateAboveBlockLimit';
import Comission from './comission';
import { Dispute } from './dispute';
import ProductApproved from './productApproved';
import ProductReproved from './productReproved';
import Refund from './Refund';
import Report from './report';
import ReportNoData from './reportNoData';
import Sales from './sales';
import Subscriptions from './subscriptions';

export default function Notifications() {
  const [notifications] = useObservable(() => notificationService.getListGroupNotifications(), []);
  const [lastUpdate] = useObservable(() => notificationService.getLastUpdate(), []);
  const [popoverOpen, setPopoverOpen] = React.useState(false);
  const permissionDenied = webNotificationService.permission === 'denied';

  useEffect(() => webNotificationService.requestPermission(), []);

  const handleClose = useCallback(() => {
    setPopoverOpen(false);
  }, []);

  const total = (notifications || []).reduce((total, notification) => total + notification.quantity, 0);

  const popoverContent = (
    <div className='min-w-[280px]'>
      <Typography.Title level={5} className='mb-0! py-2 text-center' id='notification_popover'>
        <span className='inline-flex items-center gap-2'>
          Notificações
          <Tooltip
            title={
              permissionDenied
                ? 'Notificações do navegador estão desativadas'
                : 'Notificações do navegador estão ativadas'
            }
            placement='top'
          >
            {permissionDenied ? <NotificationsOffOutlinedIcon /> : <NotificationsOutlinedIcon />}
          </Tooltip>
        </span>
      </Typography.Title>
      <Divider className='my-0!' />
      {!total ? (
        <div className='p-4 text-center text-sm text-[#333]'>Não há notificações</div>
      ) : (
        <div onClick={handleClose} className='divide-y divide-[#f0f0f0]'>
          <Refund />
          <Dispute />
          <Sales />
          <BankslipGenerated />
          <ProductApproved />
          <ProductReproved />
          <Report />
          <ReportNoData />
          <Comission />
          <HighChargebackRate />
          <Subscriptions />
        </div>
      )}
      <Divider className='my-0!' />
      <div className='flex items-center justify-between px-3 py-1.5 text-xs text-[#928989]'>
        <Button size='small' type='text' icon={<HistoryIcon />} disabled>
          {lastUpdate}
        </Button>
        <Link to='/producer/notifications?readAll=true'>
          <Tooltip title='Ao exibir todas notificações todos contadores serão limpos' placement='bottom'>
            <Button size='small' type='text' onClick={handleClose}>
              Exibir tudo
            </Button>
          </Tooltip>
        </Link>
      </div>
    </div>
  );

  return (
    <Popover
      open={popoverOpen}
      onOpenChange={setPopoverOpen}
      content={popoverContent}
      trigger='click'
      placement='bottom'
    >
      <Tooltip title='Notificações' placement='bottom' open={popoverOpen ? false : undefined}>
        <span>
          <Topbar.Action
            id='topbar-action-notifications'
            aria-label='mostrar notificações'
            icon={
              <Badge count={total} offset={[0, 5]}>
                <NotificationOutlineIcon style={{ fontSize: 24, color: 'currentColor' }} />
              </Badge>
            }
          />
        </span>
      </Tooltip>
    </Popover>
  );
}
